import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'stripHtml',
    standalone: false
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    try {
      const doc = new DOMParser().parseFromString(value, 'text/html');
      return (doc.body.textContent || doc.body.innerText || '').trim();
    } catch (error) {
      return value.replace(/<[^>]*>/g, '').trim();
    }
  }
}
